import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  Grid,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  CircularProgress,
  useMediaQuery,
  Alert,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fade,
  Chip,
  Switch,
  IconButton,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/WarningRounded';
import PublishRoundedIcon from '@mui/icons-material/PublishRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import React, { useEffect, useState } from 'react';
import { BuybackPriceDialog } from './Price/BuybackPriceDialog';
import { useTheme } from '@emotion/react';
import { useToastContext } from './toast-context';
import { services } from '../pages/Sell/services';
import ConfirmFloorPriceDialog from './confirm-floor-price-dialog'; // ایمپورت دایلاگ تایید مجزا

const PreviewBuybackPrice = ({
  manualBasePrice,
  setShowPreview,
  setProductConfig,
  changedPreviewProductConfig,
  setBullionsConfig,
  configValues,
  trig,
  type,
  trigger,
  openDialog,
  bullionTypes,
  manualPriceLessThanThreshhold,
  manualPriceMoreThanThreshhold,
}) => {
  const theme = useTheme();
  const [isPreviewSubmitting, setIsPreviewSubmitting] = React.useState();

  // افزودن متغیرهای حالت مدیریت وضعیت سوئیچ قیمت منبع
  const [calculateFloorPriceForBuyback, setcalculateFloorPriceForBuyback] =
    useState(!!configValues?.calculateFloorPriceForBuyback);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const [openFloorPriceConfirm, setOpenFloorPriceConfirm] = useState(false);

  const { showToast } = useToastContext();

  const commaRemovedManualBasePrice = !!String(
    configValues?.manualBasePrice
  )?.includes(',')
    ? Number(configValues.manualBasePrice.replace(/,/g, ''))
    : configValues.manualBasePrice;

  // گنجاندن تغییر وضعیت سوئیچ جدید در اعتبارسنجی تغییرات
  // const hasConfigChanged =
  //   currentManualBasePrice !== commaRemovedManualBasePrice ||
  //   !!changedPreviewProductConfig.length;

  const firstCategory = bullionTypes.slice(0, 7);
  const secondCategory = bullionTypes.slice(7);

  const handleSave = async () => {
    try {
      setIsPreviewSubmitting(true);
      const config = {
        strategy: 'MANUAL',
        calculateFloorPriceForBuyback: calculateFloorPriceForBuyback,
      };

      if (
        commaRemovedManualBasePrice !== null &&
        commaRemovedManualBasePrice !== undefined
      ) {
        config.manualBasePrice =
          manualBasePrice === '0' ? 0 : commaRemovedManualBasePrice;
      }
      let fetchedOnlineBuyback = false;
      await services.getProductsConfig({}).then(res => {
        fetchedOnlineBuyback =
          res?.find(b => b.productType === 'GB_999_10')
            ?.isBuybackOnlineActive ?? false;
        console.log(
          'yasin',
          res?.find(b => b.productType === 'GB_999_10'),
          res?.find(b => b.productType === 'GB_999_10')?.isBuybackOnlineActive,
          fetchedOnlineBuyback
        );
      });

      await services.setProductConfig({
        isApplyingToAll: true,
        transactionType: 'SELL',
        buybackStrategy: 'MANUAL',
        isBuybackOnlineActive: fetchedOnlineBuyback,
        manualBaseBuybackPrice: config.manualBasePrice,
        calculateFloorPriceForBuyback: !calculateFloorPriceForBuyback, // ارسال فلگ جدید
      });
      showToast('قیمت جدید با موفقیت ثبت شد.', 'success');

      await Promise.all(
        changedPreviewProductConfig.map(async product => {
          const { productType, ...rest } = product;
          await setProductConfig(rest, productType);
        })
      );

      setIsPreviewSubmitting(false);
      setShowPreview(false);
      setOpenConfirmModal(false);
      trig();
    } catch (error) {
      console.error('Error submitting configuration:', error);
      let toastMessage = error.response?.data?.message || 'خطایی رخ داد.';
      showToast(toastMessage, 'error');
      setIsPreviewSubmitting(false);
    }
  };

  const handleToggleSwitchChange = e => {
    const checked = e.target.checked;
    if (checked) {
      setOpenFloorPriceConfirm(true);
    } else {
      setcalculateFloorPriceForBuyback(false);
    }
  };

  const handleConfirmFloorPrice = () => {
    setcalculateFloorPriceForBuyback(true);
    setOpenFloorPriceConfirm(false);
  };

  const handleCancelFloorPrice = () => {
    setOpenFloorPriceConfirm(false);
  };

  // --- "BUYBACK PREVIEW" THEME (ORANGE) ---
  const previewTheme = {
    primary: '#ea580c', // Orange 600
    dark: '#9a3412', // Orange 900
    accent: '#c2410c', // Orange 700
    containerBg: '#fff7ed', // Orange 50
    borderStyle: '2px dashed #fb923c',
    tableBg: '#ffffff',
    highlight: '#fffbeb', // Amber 50
    rowHover: '#ffedd5', // Orange 100
  };

  const renderTableRow = (bullion, index) => {
    const isChanged = changedPreviewProductConfig.find(
      changed => changed.productType === bullion.key
    );

    return (
      <TableRow
        key={bullion.key}
        onClick={e => {
          if (e.target.type !== 'checkbox') {
            openDialog(
              `${String(bullion.name || '')} گرمی`,
              <BuybackPriceDialog
                is995={!!bullion.key.includes('GB_995')}
                isPreview
                manualBaseBuybackPriceDefault={
                  !!String(manualBasePrice)?.includes(',')
                    ? Number(manualBasePrice?.replace(/,/g, ''))
                    : Number(manualBasePrice)
                }
                trigger={trigger}
                trig={trig}
                strategy={'MANUAL'}
                strategyDefault={bullion.buybackStrategy}
                priceDefault={Number(bullion.manualPreviewBuybackPrice)}
                cutNumberDefault={bullion.manualPreviewBuybackCutNumber}
                profitPercentageDefault={
                  bullion.previewManualBuybackMarginPercentage
                }
                manualPriceLessThanThreshhold={manualPriceLessThanThreshhold}
                manualPriceMoreThanThreshhold={manualPriceMoreThanThreshhold}
                setBullionsConfig={setBullionsConfig}
                bullionWeight={bullion.weight}
                onClick={data =>
                  bullion.dialogProps.onClick({ isPreview: true, data })
                }
              />
            );
          }
        }}
        sx={{
          borderLeft: isChanged
            ? `4px solid ${previewTheme.primary}`
            : '4px solid transparent',
          backgroundColor: isChanged
            ? previewTheme.highlight
            : index % 2 === 0
              ? '#ffffff'
              : '#fafafa',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: previewTheme.rowHover,
            transform: 'scale(1.002) translateX(-2px)',
            boxShadow: '0 4px 12px rgba(234, 88, 12, 0.08)',
            zIndex: 10,
            position: 'relative',
          },
          '& td': {
            borderBottom: '1px solid #fed7aa',
            py: 1.8,
            px: 2,
            fontSize: '0.875rem',
            color: '#334155',
            fontWeight: isChanged ? 700 : 500,
          },
        }}
      >
        <TableCell>
          {isChanged && (
            <Box
              component="span"
              sx={{ color: previewTheme.primary, mr: 1, fontSize: '0.7rem' }}
            >
              ●
            </Box>
          )}
          {String(bullion.name || '')}
        </TableCell>

        <TableCell>
          <Tooltip
            title={`هرگرم ${(Number(bullion.manualPreviewBuybackPrice) / bullion.weight).toLocaleString('fa-IR')} ریال`}
            arrow
            placement="top"
          >
            <Typography
              variant="body2"
              fontWeight={700}
              sx={{ color: previewTheme.primary }}
            >
              {Number(bullion.manualPreviewBuybackPrice).toLocaleString(
                'fa-IR'
              )}{' '}
              ریال
            </Typography>
          </Tooltip>
        </TableCell>

        <TableCell>
          <span
            style={{
              color:
                Number(bullion.previewBuybackProfitMargin) > 0
                  ? '#16a34a'
                  : '#ef4444',
              fontWeight: 700,
            }}
          >
            {Number(bullion.previewBuybackProfitMargin).toLocaleString('fa-IR')}
            %
          </span>
        </TableCell>

        <TableCell>
          <span
            style={{
              color:
                Number(bullion.previewManualBuybackMarginPercentage) > 0
                  ? '#16a34a'
                  : '#ef4444',
              fontWeight: 700,
            }}
          >
            {bullion.previewManualBuybackMarginPercentage !== null
              ? `${Number(bullion.previewManualBuybackMarginPercentage ?? 0).toLocaleString('fa-IR')}%`
              : '---'}
          </span>
        </TableCell>

        <TableCell>
          {bullion.manualPreviewBuybackCutNumber !== null
            ? `${Number(bullion.manualPreviewBuybackCutNumber ?? 0).toLocaleString('fa-IR')} رقم`
            : '---'}
        </TableCell>
      </TableRow>
    );
  };

  const renderDividerRow = () => (
    <TableRow>
      <TableCell
        colSpan={5}
        sx={{ p: 0, height: '16px', bgcolor: 'transparent', border: 'none' }}
      />
    </TableRow>
  );

  return (
    <Grid item xs={12} mt={'24px'}>
      <Fade in={true} timeout={500}>
        <Box
          sx={{
            borderRadius: '24px',
            border: previewTheme.borderStyle,
            backgroundColor: previewTheme.containerBg,
            p: { xs: 2, sm: 3 },
            position: 'relative',
            boxShadow: '0 10px 30px -10px rgba(234, 88, 12, 0.15)',
          }}
        >
          {/* دکمه بستن در گوشه بالا سمت چپ به صورت کوچک، بدون پس‌زمینه و فاقد کادر */}
          <Tooltip title="لغو تغییرات" arrow>
            <IconButton
              onClick={() => setShowPreview(false)}
              sx={{
                position: 'absolute',
                top: { xs: 12, sm: 20 },
                right: { xs: 12, sm: 20 },
                color: '#dc2626',
                bgcolor: 'transparent',
                border: 'none',
                p: 0.5,
                zIndex: 10,
                '&:hover': {
                  bgcolor: 'rgba(220, 38, 38, 0.08)',
                  color: '#b91c1c',
                },
              }}
            >
              <CloseRoundedIcon sx={{ fontSize: '1.25rem' }} />
            </IconButton>
          </Tooltip>

          {/* --- Action Header --- */}
          <Stack
            width={'100%'}
            justifyContent="space-between"
            alignItems={{ xs: 'flex-start' }}
            mb={4}
            mt={1}
            gap={3}
          >
            {/* عنوان و توصیف */}
            <Box>
              <Typography
                variant="h5"
                fontWeight={800}
                color={previewTheme.dark}
                letterSpacing="-0.5px"
              >
                بررسی نهایی قیمت‌ها
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: previewTheme.accent, fontWeight: 500, mt: 0.5 }}
              >
                تغییرات قیمت خرید از مشتری در این لیست آماده تایید است.
              </Typography>
            </Box>

            {/* سوئیچ تنظیمات و دکمه اصلی در کنار هم (قرینه ساختار PreviewPrice) */}
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              width={'100%'}
              justifyContent={'space-between'}
            >
              {/* دکمه دوحالته با استایل همسان دایلاگ */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  bgcolor: calculateFloorPriceForBuyback
                    ? '#FEF2F2'
                    : '#ffffffff',
                  border: calculateFloorPriceForBuyback
                    ? '1px solid #FCA5A5'
                    : '1px dashed #FCA5A5',
                  borderRadius: '12px',
                  px: 2,
                  py: 0.75,
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: calculateFloorPriceForBuyback
                      ? '#991B1B'
                      : '#334155',
                    fontSize: '0.8rem',
                    transition: 'color 0.2s ease-in-out',
                    userSelect: 'none',
                  }}
                >
                  نادیده گرفتن قیمت مرجع
                </Typography>
                <Switch
                  checked={calculateFloorPriceForBuyback}
                  onChange={handleToggleSwitchChange}
                  color="error"
                  size="small"
                />
              </Box>

              {/* دکمه اعمال قیمت‌ها */}
              <Button
                variant="contained"
                onClick={() => handleSave()}
                disabled={
                  isPreviewSubmitting ||
                  manualPriceLessThanThreshhold ||
                  manualPriceMoreThanThreshhold
                }
                startIcon={
                  isPreviewSubmitting ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <PublishRoundedIcon />
                  )
                }
                sx={{
                  borderRadius: '12px',
                  background: `linear-gradient(135deg, ${previewTheme.primary} 0%, ${previewTheme.accent} 100%)`,
                  px: 3,
                  py: 1.2,
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  boxShadow: '0 8px 20px -4px rgba(234, 88, 12, 0.5)',
                  '&:hover': {
                    background: `linear-gradient(135deg, ${previewTheme.accent} 0%, ${previewTheme.dark} 100%)`,
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 24px -4px rgba(234, 88, 12, 0.6)',
                  },
                  '&.Mui-disabled': {
                    bgcolor: '#cbd5e1',
                    color: '#fff',
                    boxShadow: 'none',
                  },
                }}
              >
                {isPreviewSubmitting ? 'در حال ذخیره...' : 'اعمال قیمت‌ها'}
              </Button>
            </Stack>
          </Stack>

          {/* --- Data Table --- */}
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
              border: `1px solid ${previewTheme.borderStyle.split(' ')[2]}`,
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    'شمش',
                    'قیمت بازخرید (پیش‌نمایش)',
                    'اختلاف با مرجع قیمت',
                    'اختلاف از قیمت پایه',
                    'گردشده',
                  ].map(head => (
                    <TableCell
                      key={head}
                      sx={{
                        background: `repeating-linear-gradient(
                                    45deg,
                                    ${previewTheme.primary},
                                    ${previewTheme.primary} 10px,
                                    ${previewTheme.accent} 10px,
                                    ${previewTheme.accent} 20px
                                )`,
                        color: '#fff',
                        fontWeight: 800,
                        py: 2,
                        px: 2,
                        fontSize: '0.85rem',
                        whiteSpace: 'nowrap',
                        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody sx={{ bgcolor: previewTheme.tableBg }}>
                {firstCategory.map((bullion, index) =>
                  renderTableRow(bullion, index)
                )}
                {renderDividerRow()}
                {secondCategory.map((bullion, index) =>
                  renderTableRow(bullion, index + 7)
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Fade>

      {/* --- دایلاگ تایید نادیده گرفتن قیمت مرجع --- */}
      <ConfirmFloorPriceDialog
        open={openFloorPriceConfirm}
        onClose={handleCancelFloorPrice}
        onConfirm={handleConfirmFloorPrice}
        title="تایید نادیده گرفتن قیمت مرجع"
        message="با این اقدام، قیمت‌گذاری بدون سنجش با مرجع اصلی (اتحادیه/فراز) انجام خواهد شد و ریسک مالی افزایش می‌یابد. آیا مطمئن هستید؟"
      />
    </Grid>
  );
};

export default PreviewBuybackPrice;
